import { RateInterface } from '@bellawatt/electric-rate-engine';
import { RateKey, RateTerritory } from '../../types';
import eone from './e1.json';
import eone_territories from './e1_territories.json';
import eelec from './eelec.json';
import eelec_territories from './eelec_territories.json';
import etouc from './etouc.json';
import etouc_territories from './etouc_territories.json';
import etoud from './etoud.json';
import etoud_territories from './etoud_territories.json';
import ev2a from './ev2a.json';
import ev2a_territories from './ev2a_territories.json';

const RATES: Record<RateKey, RateInterface | null> = {
  'E-1': eone as RateInterface,
  'E-ELEC': eelec as RateInterface,
  'EV2-A': ev2a as RateInterface,
  'E-TOU-C': etouc as RateInterface,
  'E-TOU-D': etoud as RateInterface,
  'EV-B': null,
};

export default RATES;

export const TERRITORIES: Record<RateKey, Record<string, RateTerritory> | null> = {
  'E-1': eone_territories as Record<string, RateTerritory>,
  'EV2-A': ev2a_territories as Record<string, RateTerritory>,
  'E-ELEC': eelec_territories as Record<string, RateTerritory>,
  'E-TOU-C': etouc_territories as Record<string, RateTerritory>,
  'E-TOU-D': etoud_territories as Record<string, RateTerritory>,
  'EV-B': null,
};
